import PinInput from './PinInput';

export type { PinInputProps } from './PinInput';
export { PinInput };
export default PinInput;
